/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

export const JOB_STATUS_PENDING = 'pending'
export const JOB_STATUS_STARTED = 'started'
export const JOB_STATUS_FAILED = 'failed'
export const JOB_STATUS_ENDED = 'ended'

const JobStatusCodes = [
  JOB_STATUS_PENDING,
  JOB_STATUS_STARTED,
  JOB_STATUS_FAILED,
  JOB_STATUS_ENDED
]

export default JobStatusCodes
